import React from 'react';
import '../style/toba.css'
import Button from "./button";
import GeneralSVG from "./generalSVG";
import CenteredDots from "./General/centeredDots";
import FormResponseMessage from "./formResponseMessage";
import { TOBA_FULL_TEXT } from '../helpers/variables';

const AcceptedToba = (props) => {
    
    let pageContent = (
        <div>
            {
                props.Toba.tobaAttachmentDtos?
                    props.Toba.tobaAttachmentDtos.length > 0?
                        <div className="">
                            <div className="col-sm-12">
                                <h4 >Files Attached</h4>
                                <ul className="newApplication-attachment-list">
                                    {
                                        props.Toba.tobaAttachmentDtos.map((attachments, index) => {
                                            return <li key={index}>
                                                <a onClick={() => props._getFileFromBase64(attachments)}
                                                   className="applicationPolicy-document-tab-link">
                                                    <GeneralSVG
                                                        SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                        Label="Download"
                                                        Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 10 10"><title>Asset
                                                            9</title>
                                                            <g id="Layer_2" data-name="Layer 2">
                                                                <g id="info">
                                                                    <path
                                                                        d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                    <path
                                                                        d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                </g>
                                                            </g>
                                                        </svg>}
                                                    />
                                                </a>
                                                {' ' + attachments.name}
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        :
                        null
                    :
                    null
            }
        </div>
    );
    if(props.fetchingAcceptedToba){
        pageContent =  <div className={'col-sm-12'}><CenteredDots/></div>
    }
    if(props.fetchingAcceptedTobaFailMessage){
        return 	(
           <div className={'row'}>
               <FormResponseMessage
                   Message={props.fetchingAcceptedTobaFailMessage}
                   CenterWrapper="col-sm-12 mb-15"
                   MessageStyle="formResponseMessage-reject" />
           </div>
        )

    }
    return (
        <div className="row">
            <div className="">
                <div className="col-xs-8">
                    <h2 className="toba-h2"> Accepted {TOBA_FULL_TEXT} </h2>
                    <div className="" dangerouslySetInnerHTML={{__html:props.Toba.content}}>
                    </div>
                </div>
            </div>
            {pageContent}
            <div className="">
                <div className="col-xs-8">
                    <Button
                        clickHandler={() => props.push('/manage-account')}
                        wrapper="btn-wrapper-forForms"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp white'}
                        label="Go back"
                    />
                </div>
            </div>
            {
                (!props.fetchingAcceptedToba && !props.fetchingAcceptedTobaFailMessage) && (
                    <h6 className={'col-xs-12'}>
                        {'Name: ' + props.Toba.name + ' | Version: ' + props.Toba.version}
                    </h6>
                )
            }
        </div>
    )

};

export default AcceptedToba;